export default [
  'tania@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'albane@foodforjoe.es',
  'dana@foodforjoe.es',
  'data@foodforjoe.com',
  'adriana.molvinger@foodforjoe.es',
  'miriam@foodforjoe.es',
  'diego@foodforjoe.es',
  'josep@foodforjoe.es',
  'lucia.mercedes@foodforjoe.es',
  'carla@foodforjoe.es',
  'noelia@foodforjoe.es',
  'erika.lazaro@foodforjoe.es',
  'juan@foodforjoe.es',
  'flavia@foodforjoe.com',
  'almacen.massanes@foodforjoe.es',
  'sonia.cortes@foodforjoe.es',
  'compras@foodforjoe.es',
  'elena@foodforjoe.es',
  'antonella@foodforjoe.es',
  'laia@foodforjoe.es',
  'jonathan@foodforjoe.com',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
  'laura.diaz@foodforjoe.es',
  'denisse@foodforjoe.es',
  'jordi.antoja@foodforjoe.com',
];
